export const name = 'accessibilityBrowserZoom' as const
